import { Card, type CardProps } from '@mui/material'
import { type PropsWithChildren, useState } from 'react'
import type { EventDTO } from '~entities/index'
import { EventDetailsModal } from './eventDetailsModal'
import { LinkQRCodeModal } from './linkQRCodeModal'

type BaseEventCardProps = PropsWithChildren<CardProps> & {
	info: EventDTO | undefined
}

export const BaseEventCard = ({
	children,
	info,
	...props
}: BaseEventCardProps) => {
	const [open, setOpen] = useState(false)
	const [isLinkOpen, setIsLinkOpen] = useState(false)
	const [link, setLink] = useState<string | null>()
	return (
		<>
			<Card onClick={() => setOpen(true)} {...props}>
				{children}
			</Card>
			<EventDetailsModal
				sx={{ display: isLinkOpen ? 'none' : undefined }}
				setLink={setLink}
				info={info}
				open={open}
				onClose={() => {
					setOpen(false)
				}}
				isLinkOpen={isLinkOpen}
				setIsLinkOpen={setIsLinkOpen}
			/>
			<LinkQRCodeModal
				link={link}
				open={isLinkOpen}
				onClose={() => setIsLinkOpen(false)}
			/>
		</>
	)
}
